
(function () {
  'use strict';

  function updateArrows(track) {
    var wrapper = track.closest('.sml-nc__products');

    if (!wrapper) return;

    var previous = wrapper.querySelector('[data-nc-prev]');
    var next = wrapper.querySelector('[data-nc-next]');
    var maximum = Math.max(
      0,
      track.scrollWidth - track.clientWidth
    );

    if (previous) {
      previous.disabled =
        track.scrollLeft <= 3 || maximum <= 3;
    }

    if (next) {
      next.disabled =
        track.scrollLeft >= maximum - 3 || maximum <= 3;
    }
  }

  function initialiseCarousels(scope) {
    (scope || document)
      .querySelectorAll('.sml-nc [data-nc-track]')
      .forEach(function (track) {
        if (track.dataset.ncInitialised !== 'true') {
          track.dataset.ncInitialised = 'true';

          track.addEventListener(
            'scroll',
            function () {
              updateArrows(track);
            },
            { passive: true }
          );

          if ('ResizeObserver' in window) {
            new ResizeObserver(function () {
              updateArrows(track);
            }).observe(track);
          }
        }

        updateArrows(track);
      });
  }

  function handleClick(event) {
    var quantityButton = event.target.closest(
      '.sml-nc [data-nc-quantity]'
    );

    if (quantityButton) {
      var form = quantityButton.closest('.sml-nc__form');
      var input = form && form.querySelector(
        'input[name="quantity"]'
      );

      if (input) {
        input.value = Math.max(
          1,
          (parseInt(input.value, 10) || 1) +
          Number(quantityButton.dataset.ncQuantity)
        );
      }

      return;
    }

    var thumbnail = event.target.closest(
      '.sml-nc [data-nc-thumbnail]'
    );

    if (thumbnail) {
      var card = thumbnail.closest('.sml-nc__card');
      var image = card && card.querySelector(
        '.sml-nc__main-image'
      );

      if (!image) return;

      image.src = thumbnail.dataset.ncImage;
      image.removeAttribute('srcset');
      image.alt = thumbnail.dataset.ncAlt || image.alt;

      card
        .querySelectorAll('[data-nc-thumbnail]')
        .forEach(function (button) {
          var selected = button === thumbnail;

          button.classList.toggle(
            'is-active',
            selected
          );

          button.setAttribute(
            'aria-pressed',
            String(selected)
          );
        });

      return;
    }

    var arrow = event.target.closest(
      '.sml-nc [data-nc-prev], .sml-nc [data-nc-next]'
    );

    if (arrow && !arrow.disabled) {
      var wrapper = arrow.closest('.sml-nc__products');
      var track = wrapper && wrapper.querySelector(
        '[data-nc-track]'
      );

      var card = track && track.querySelector(
        '.sml-nc__card'
      );

      if (!card) return;

      var step =
        card.getBoundingClientRect().width +
        (parseFloat(getComputedStyle(track).gap) || 0);

      var reduced = window
        .matchMedia('(prefers-reduced-motion: reduce)')
        .matches;

      track.scrollBy({
        left: step * (
          arrow.hasAttribute('data-nc-prev') ? -1 : 1
        ),
        behavior: reduced ? 'auto' : 'smooth'
      });
    }
  }

  async function handleSubmit(event) {
    var form = event.target;

    if (!form.matches('.sml-nc .sml-nc__form')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var button = form.querySelector('[data-nc-add]');
    var status = form.querySelector('[data-nc-status]');

    if (!button || button.disabled) return;

    var oldText = button.textContent;

    button.disabled = true;
    button.textContent = 'ADDING…';

    if (status) {
      status.textContent = '';
    }

    try {
      var root =
        (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        ) || '/';

      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form),
        credentials: 'same-origin'
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || 'Unable to add this product.'
        );
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: result,
            quantity: Number(
              form.querySelector('[name="quantity"]').value
            ) || 1
          }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      button.textContent = 'ADDED';

      if (status) {
        status.textContent = 'Added to basket.';
      }

    } catch (error) {
      button.textContent = oldText;

      if (status) {
        status.textContent =
          error.message || 'Please try again.';
      }

    } finally {
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = oldText;
      }, 1100);
    }
  }

  function initialise() {
    initialiseCarousels(document);

    if (!window.__smlNewCollectionsBound) {
      window.__smlNewCollectionsBound = true;

      document.addEventListener(
        'click',
        handleClick
      );

      document.addEventListener(
        'submit',
        handleSubmit,
        true
      );

      window.addEventListener(
        'resize',
        function () {
          initialiseCarousels(document);
        }
      );

      document.addEventListener(
        'shopify:section:load',
        function () {
          initialiseCarousels(document);
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );
  } else {
    initialise();
  }
})();
